import React, { Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import './App.css'
import ExpiredWarning from './pages/users/ExpiredWarning'
import MemberLogin from './pages/auth/MemberLogin'
import InvitationPage from './pages/users/dashboard/AccountSettings/TeamMembers/InvitationPage'

const Login = React.lazy(() => import('./pages/auth/Login'))
const ForgotPassword = React.lazy(() => import('./pages/auth/ForgotPassword'))
const SignUp = React.lazy(() => import('./pages/auth/SignUp'))
const ChangePassword = React.lazy(() => import('./pages/auth/ChangePassword'))
const VerifyEmail = React.lazy(() => import('./pages/auth/VerifyEmail'))
const DashboardLayout = React.lazy(() => import('./layouts/DashboardLayout'))
const PublicStat = React.lazy(() => import('./pages/users/dashboard/ScanStats'))
const RedirectPage = React.lazy(() => import('./pages/RedirectPage'))
const RedirectLandingPage = React.lazy(() => import('./pages/RedirectLandingPage'))
const AdminLogin = React.lazy(() => import('./pages/auth/AdminLogin'));
const AdminSignup = React.lazy(() => import('./pages/auth/AdminSignup'));
const AdminDashboard = React.lazy(() => import('./pages/admin/index'));

function App() {
  return (
    <Router>
      <Suspense>
        <Routes>
        
          <Route path='/' exact element={<Login />} />
          <Route path='/member-login/:teamId' exact element={<MemberLogin />}/>
          <Route path='/sign-up' exact element={<SignUp />} />
          <Route path='/forgot-password' exact element={<ForgotPassword />} />
          <Route path='/change-password/:token' exact element={<ChangePassword />} />
          <Route path='/verify/:token' exact element={<VerifyEmail />} />
          <Route path='/expired-warning' exact element={<ExpiredWarning />} />
          <Route path='/dashboard/*' exact element={<DashboardLayout />} />
          <Route path="/accept-invitation/:encodeduser"  element={<InvitationPage />} />
          <Route path='/public-stats/:id' exact element={<PublicStat />} />
          <Route path='/:id' exact element={<RedirectPage />} />
          <Route path='/page/:slugId' element={<RedirectLandingPage />} />

          <Route path='/admin/sign-up' exact element={<AdminSignup />} />
          <Route path='/admin/login' exact element={<AdminLogin />} />
          <Route path='/admin/dashboard/*' exact element={<AdminDashboard />} />
        </Routes>
        <ToastContainer position='top-right' autoClose='3000' hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable theme='colored' />
      </Suspense>
    </Router>
  )
}

export default App
